import React, { FC, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import SettingsView from "../../shared/settingsView";
import { ResultsTableRowData, SettingsParams, SettingsType } from "../types";
import { ExtractAccountData } from "../../../../../models/extractAccountDataPatterns";
import { getSettings } from "../../../../../services/get.data.service";
// import SettingsTitle from "../../shared/settingsTitle";
import ExtractAccountDataPatternsForm from "./extractAccountDataPatternsForm";
// import SettingsTable from "../../shared/table/table";
import isDuplicate from "../../shared/helpers/isDuplicate";

const ExtractAccountDataPatternsSettings: FC = () => { 
  const { id }: SettingsParams = useParams();
  const [ data, setData ] = useState<ExtractAccountData[]>([]);
    
  const loadData = (): void => {
    getSettings<ExtractAccountData>("actionextractaccountdata").then((response) => {
      setData(response.data);
    });
  };

  useEffect(() => {
    loadData();
  }, []);

  const existingExtractAccountData = data?.find((data) => data.actionExtractAccountDataId === Number(id));

  const rows: ResultsTableRowData[] | null =
    data &&
    data.map((extractAccountData) => {
      const id = extractAccountData.actionExtractAccountDataId;
      return {
        id: id,
        data: [
          extractAccountData.platform,
          <Link key={`lis-${id}`} to={`/system-settings/accountdataextractions/edit/${id}`}>
            Edit
          </Link>,
        ],
      };
    });

  return (
    <SettingsView
      headers={["Platform", ""]} 
      rows={rows} 
      titleSingle="Platform"
      titlePlural="Account Data Extractions"
      type={SettingsType.extractAccountData}
    >
      {data !== null && (
        <ExtractAccountDataPatternsForm  
          isDuplicate={(value): boolean => {
            return isDuplicate(data.map((item)=>{
              return {
                id: item.actionExtractAccountDataId,
                value: item.platform.toLowerCase(),
              };              
            }), value, Number(id));
          }}
          existingExtractAccountData={existingExtractAccountData}
          load={loadData}
        />
      )}
    </SettingsView>
  );
};
export default ExtractAccountDataPatternsSettings;
